exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Popup-module__popup-background___36siS{background-color:rgba(36,44,64,.7);position:absolute;top:0;left:0;width:100%;height:100%;z-index:801;cursor:pointer;visibility:hidden;overflow:visible;opacity:0;transition:all .4s}.Popup-module__popup-background___36siS.Popup-module__visible___3FJtl{opacity:1;visibility:visible}.Popup-module__popup-background___36siS .Popup-module__popup-content___2thkf{opacity:1;color:#fff;width:100%;height:100%}", ""]);

// exports
exports.locals = {
	"popup-background": "Popup-module__popup-background___36siS",
	"visible": "Popup-module__visible___3FJtl",
	"popup-content": "Popup-module__popup-content___2thkf"
};